<template>
  <div class="row" v-if="workOrder">
    <div class="col-sm-3">
      <h1>{{ workOrder.orderNumber }}</h1>
    </div>
    <div class="col-sm-6 d-none d-lg-block"><h3>Kontrolni list</h3></div>
    <div class="col-sm-3">
      <h2><OrderBadge :workOrder="workOrder" /></h2>
    </div>
  </div>

  <div class="row mb-3 mt-3" v-if="workOrder">
    <div class="col-md-8"></div>
    <div class="col-md-4">
      <div class="card mb-3" v-if="device">
        <div class="card-body">
          <p class="card-text">Naprava: {{ device.deviceNumber }}</p>
          <p class="card-text" v-show="device.label">Nalepka: {{ device.label }}</p>
          <p class="card-text">Objekt: {{ device.facility?.name }}</p>
          <p class="card-text" v-show="device.attributes.find((a) => a.name === 'UnitType')?.value">
            Tip:
            {{ device.attributes.find((a) => a.name === "UnitType")?.value }}
          </p>
          <p class="card-text" v-show="device.attributes.find((a) => a.name === 'UnitSubTypes')?.value">
            Podtip:
            {{ device.attributes.find((a) => a.name === "UnitSubTypes")?.value }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <RequiredWarning v-show="!isValid" />

  <div class="row mt-5" v-show="!!device">
    <div class="col">
      <div class="table-responsive">
        <table class="table table-stripped table-sm table-hover">
          <thead>
            <tr>
              <th>Storitev</th>
              <th class="d-none d-lg-table-cell">Metoda</th>
              <th>Izvedeno</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="c in entity?.checklistAnswers" :key="c.itemKey">
              <td :colspan="c.isTitle ? 4 : 1">{{ c.label }}</td>
              <td v-if="!c.isTitle" class="d-none d-lg-table-cell">{{ c.note }}</td>
              <td v-if="!c.isTitle">
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    :name="'is__' + c.itemKey"
                    :id="'is__yes_' + c.itemKey"
                    :value="true"
                    v-model="c.isChecked"
                    @change="handleCheckChange(c)"
                  />
                  <label class="form-check-label" :for="'is__yes_' + c.itemKey">Da</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    :name="'is__' + c.itemKey"
                    :id="'is__no_' + c.itemKey"
                    :value="false"
                    v-model="c.isChecked"
                    @change="handleCheckChange(c)"
                  />
                  <label class="form-check-label" :for="'is__no_' + c.itemKey">Ne</label>
                </div>
              </td>
              <td v-if="!c.isTitle"><textarea rows="2" class="form-control" v-model="c.status"></textarea></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col">
      <label for="notes" class="form-label">Zaključne opombe</label>
      <textarea id="notes" rows="4" class="form-control" v-model="entity.finalRemarks"></textarea>
    </div>
  </div>

  <div class="row mt-5 mb-5">
    <div class="col-2">
      <button class="btn btn-danger btn-lg me-3" type="button" v-show="false">Izbriši</button>
    </div>
    <div class="col-10 text-end">
      <button
        class="btn btn-outline-secondary me-3"
        type="button"
        @click="$router.push({ name: 'ServiceOrder', params: { workOrderId: workOrder.id } })"
      >
        Prekliči
      </button>
      <button class="btn btn-success btn-lg me-3" type="button" @click="saveAsync" :disabled="!isValid">Shrani</button>
    </div>
  </div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import { useWorkOrder } from "../composition-api/useWorkOrder"
import { useAuth } from "../composition-api/useAuth"
import { DATETIME_FORMAT, EMPTY_GUID } from "../utils/constants"
import { getEntityAsync, saveChecklistAsync } from "../api"

defineOptions({ name: "Checklist" })

const route = VueRouter.useRoute()
const router = VueRouter.useRouter()
const { fetchAuthAsync } = useAuth()

const entity = ref({})
const device = ref(null)
const { devices, workOrder } = useWorkOrder("Service")

const handleCheckChange = (c) => {
  c.checkedAt = dayjs().toISOString()
}

const saveAsync = async () => {
  console.log("Saving checklist...", entity.value)
  const saved = await saveChecklistAsync(fetchAuthAsync, entity.value, true)
  if (saved) {
    router.push({ name: "ServiceOrder", params: { workOrderId: workOrder.value.id } })
  }
}

const loadSystemReportAsync = async () => {
  entity.value = await getEntityAsync(fetchAuthAsync, `SystemReport/${route.params.workOrderId}`, route.params.deviceId)
  device.value = await getEntityAsync(fetchAuthAsync, "Device", entity.value.deviceID)

  if (entity.value?.checklistAnswers) {
    entity.value.checklistAnswers.forEach((item) => (item.isChecked = item.isTitle ? false : null))
  }
}

const isValid = computed(() =>
  entity.value.checklistAnswers?.every(
    (entry) => entry.isChecked === false || entry.isChecked === true || entry.isTitle,
  ),
)

watch(() => route.params.deviceId, loadSystemReportAsync)

watch(() => route.params.workOrderId, loadSystemReportAsync)

onMounted(async () => loadSystemReportAsync())
</script>
